import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface NotesFormProps {
  pending: boolean;
  /** Teksten under overskriften forklarer hvorfor det ikke finnes transkripsjon. */
  reason: string;
  onSubmit: (notes: string) => void;
}

/** «Skriv notater»: referat fra verten sine notater når møtet ikke har transkripsjon (fysisk møte eller ingen opptak). */
export default function NotesForm({ pending, reason, onSubmit }: NotesFormProps) {
  const [notes, setNotes] = useState("");
  const valid = notes.trim().length > 0;
  return (
    <form
      aria-label="Skriv notater"
      className="space-y-3 border-[1.5px] border-foreground bg-card p-5"
      onSubmit={(e) => {
        e.preventDefault();
        if (valid) onSubmit(notes.trim());
      }}
    >
      <h2 className="font-display text-xl font-semibold">Skriv notater</h2>
      <p className="text-sm text-muted-foreground">{reason}</p>
      <div className="space-y-1.5">
        <Label htmlFor="meeting-notes">Notater fra møtet</Label>
        <Textarea id="meeting-notes" value={notes} onChange={(e) => setNotes(e.target.value)} rows={10} maxLength={20000} />
      </div>
      <Button type="submit" disabled={!valid || pending}>
        {pending ? "Lager referat ..." : "Lag referat"}
      </Button>
    </form>
  );
}
